import { getRoute } from '@hotjar/webapp/utils/routing';
import { PERMISSION_REQUIRED } from '@hotjar/webapp/constants/routes';
import {
  isDemoSiteId,
  redirectToDemoLogin,
} from '@hotjar/webapp/domains/acquisition/demo/demo-site-redirections';

export const navigateToPermissionRequiredPage = (siteId: number): void => {
  const next = window.location.pathname + document.location.search;
  const route = getRoute(PERMISSION_REQUIRED.BASE.path, { siteId, next });
  window.location.replace(route);
};

export const handleAjaxErrors = (response: { status: number }, siteId: number): void => {
  if (!response) {
    return;
  }

  if (response.status === 451) {
    window.location.href = 'https://www.hotjar.com/451';
  }

  if (response.status === 401 && isDemoSiteId(siteId)) {
    redirectToDemoLogin();
    return;
  }

  if ([401, 403, 404, 500, 502].includes(response.status)) {
    navigateToPermissionRequiredPage(siteId);

    return;
  }
};
